<template>
    <frontend-layout>
        <div class="flex gap-16">
            <div
                class="hidden w-[330px] flex-none border-r border-gray-300 bg-gray-50 p-8 lg:block"
            >
                <resource-post-filters
                    :categories="categories"
                    :types="types"
                    :post-filters="postFilters"
                />
            </div>

            <div class="my-8 max-w-screen-lg px-4 lg:px-0">
                <div class="mb-4 text-[24px] font-bold">Resources</div>
                <div class="flex flex-col gap-20 lg:flex-row">
                    <div class="flex-grow">
                        <div class="mb-8">
                            <form-search
                                css-classes="w-full bg-gray-200 text-[16px]"
                                placeholder="Search by title or keywords (e.g., TEI Questions)"
                                v-model="postFilters.search_text"
                            ></form-search>
                        </div>

                        <div class="flex items-center justify-between">
                            <div class="my-4 text-[14px] text-gray-600">
                                Showing {{ results.total }} results
                            </div>
                            <div class="lg:hidden">
                                <slide-over-menu open-from="right">
                                    <template #trigger>
                                        <span
                                            class="btn btn-sm rounded border font-medium text-gray-600"
                                            >Filters</span
                                        >
                                    </template>
                                    <template #menu_content>
                                        <div
                                            class="flex h-full max-h-[700px] flex-col"
                                        >
                                            <div
                                                class="flex border-b border-gray-100 p-4"
                                            >
                                                Filters
                                            </div>
                                            <div class="p-4">
                                                <resource-post-filters
                                                    :categories="categories"
                                                    :types="types"
                                                    :post-filters="postFilters"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </slide-over-menu>
                            </div>
                        </div>

                        <div class="mb-6 mt-2 flex flex-wrap gap-2 lg:hidden">
                            <div
                                v-if="
                                    postFilters.type &&
                                    postFilters.type !== 'all'
                                "
                            >
                                <div
                                    class="inline-block flex w-auto items-center justify-between rounded-full bg-gray-100 px-3 py-2"
                                >
                                    <div
                                        class="text-[16px] capitalize text-gray-700"
                                    >
                                        {{ postFilters.type }}
                                    </div>
                                    <div class="" v-on:click="clearType()">
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M13.5 4.5L4.5 13.5"
                                                stroke="#84929A"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M4.5 4.5L13.5 13.5"
                                                stroke="#84929A"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="
                                    postFilters.category &&
                                    postFilters.category !== 'all'
                                "
                            >
                                <div
                                    class="inline-block flex w-auto items-center justify-between rounded-full bg-gray-100 px-3 py-2"
                                >
                                    <div
                                        class="text-[16px] capitalize text-gray-700"
                                    >
                                        {{
                                            categories[postFilters.category]
                                                .label
                                        }}
                                    </div>
                                    <div class="" v-on:click="clearCategory()">
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M13.5 4.5L4.5 13.5"
                                                stroke="#84929A"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M4.5 4.5L13.5 13.5"
                                                stroke="#84929A"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-8" v-for="(post, index) in results.data">
                            <resource-post-excerpt-link :post="post" />
                            <div
                                class="pt-8 lg:hidden"
                                v-if="
                                    (index === 3 &&
                                        results.data.length == 10) ||
                                    (index + 1 == results.data.length &&
                                        results.data.length < 10)
                                "
                            >
                                <div v-if="Math.random() <= 0.5" class="mb-8">
                                    <emtprep-upsell-ad />
                                </div>
                                <div v-else class="mb-8">
                                    <emtce-promo-ad />
                                </div>
                            </div>
                        </div>

                        <div class="my-16">
                            <div v-if="results.data < 1" class="bg-gray-50 p-8">
                                <div class="text-center text-neutral-60">
                                    <div
                                        class="mb-4 font-semibold text-gray-900"
                                    >
                                        <span v-if="postFilters.search_text">
                                            No results for “{{
                                                postFilters.search_text
                                            }}”
                                        </span>
                                        <span v-else> No results </span>
                                    </div>
                                    <div class="">
                                        <span v-if="postFilters.search_text">
                                            Please
                                            <span class="font-semibold"
                                                >check your spelling</span
                                            >, or
                                            <span class="font-semibold"
                                                >clear your filters</span
                                            >.
                                        </span>
                                        <span v-else
                                            >Please
                                            <span class="font-semibold"
                                                >clear your filters</span
                                            >.</span
                                        >
                                        If you have additional questions you can
                                        reach us at
                                        <a
                                            class="link"
                                            href="mailto:info@emtprep.com"
                                            >info@emtprep.com</a
                                        >
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <pagination
                                    :current-page="results.current_page"
                                    :last-page="results.last_page"
                                    :total-items="results.total"
                                    v-on:prev-page="prevPage"
                                    v-on:next-page="nextPage"
                                ></pagination>
                            </div>
                        </div>
                    </div>
                    <div class="mr-4 hidden flex-none lg:block">
                        <div class="mb-8">
                            <emtprep-upsell-ad />
                        </div>
                        <div class="mb-8">
                            <emtce-promo-ad />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import Pagination from "@/Components/Pagination";
import FormSearch from "@/Components/FormSearch";
import EmtprepUpsellAd from "@/Components/EmtprepUpsellAd";
import EmtcePromoAd from "@/Components/EmtcePromoAd";
import ResourcePostExcerptLink from "@/Components/ResourcePostExcerptLink";
import SlideOverMenu from "@/Components/SlideOverMenu";
import ResourcePostFilters from "@/Components/ResourcePostFilters";

export default {
    name: "ResourceBlogIndex",
    components: {
        ResourcePostFilters,
        ResourcePostExcerptLink,
        Pagination,
        FrontendLayout,
        FormSearch,
        EmtprepUpsellAd,
        EmtcePromoAd,
        SlideOverMenu,
    },
    props: {
        results: {
            type: Object,
            default: [],
        },
        categories: {
            type: Array,
            default: [],
        },
        types: {
            type: Array,
            default: [],
        },
        selectedFilters: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            page: 1,
            postFilters: this.$inertia.form({
                category: this.selectedFilters.category,
                type: this.selectedFilters.type,
                search_text: this.selectedFilters.search_text,
            }),
        };
    },
    methods: {
        updateFilters() {
            this.$inertia.get(
                route("frontend.resources.index"),
                {
                    page: this.page,
                    category: this.postFilters.category,
                    type: this.postFilters.type,
                    search_text: this.postFilters.search_text,
                },
                {
                    preserveState: true,
                }
            );
        },
        clearType() {
            this.postFilters.type = "all";
        },
        clearCategory() {
            this.postFilters.category = "all";
        },
        nextPage: function () {
            this.page = this.page + 1;
            this.updateFilters();
        },
        prevPage: function () {
            this.page = this.page - 1;
            this.updateFilters();
        },
    },
    watch: {
        postFilters: {
            handler: _.debounce(function (newValue, oldValue) {
                this.updateFilters();
            }, 1000),
            deep: true,
        },
    },
};
</script>
